import React from "react";
import { AppBottomSheet } from "../Generic/AppBottomSheet";
import Flex from "../Generic/Flex";
import { AppOverlay } from "../Generic/AppOverlay";
import "./MystaffingPreferences.scss";
import { CaregiverStaffingPreferenceTypes } from "../../messages";
import Checkbox from "../Generic/Checkbox";
import "./MystaffingPreferences.scss";
import { ChevronRightIcon } from "../../utils/icones";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";

type Option<$Value> = {
  title: string;
  value: $Value;
};

interface StaffingPreferenceSelectProps<$Value> {
  label: string;
  type: CaregiverStaffingPreferenceTypes;
  options: Option<$Value>[];
  values: $Value[];
  onChange: (preference: CaregiverStaffingPreferenceTypes, values: $Value[]) => void;
}

function StaffingPreferenceMultiSelect<$Value>(props: StaffingPreferenceSelectProps<$Value>) {
  const [isOptionsModalOpen, setIsOptionsModalOpen] = React.useState(false);
  const selectedOptions = props.options.filter((option) => props.values.includes(option.value));

  const handleChange = (value: $Value, isChecked: boolean) => {
    const option = props.options.find((option) => option.value === value);
    if (option !== undefined) {
      const newOptions = isChecked
        ? [...selectedOptions, option]
        : selectedOptions.filter((option) => option.value !== value);

      props.onChange(
        props.type,
        newOptions.map((option) => option.value)
      );
    }
  };

  return (
    <>
      <Flex
        onClick={() => setIsOptionsModalOpen(true)}
        direction="row"
        gap={5}
        justifyContent="space-between"
        alignItems="center"
      >
        <Flex direction="column" gap={4}>
          <div> {props.label} </div>
          <div className="MyStaffingPreferences__Answer">
            {selectedOptions.length === 0
              ? translate(STRINGS.NOT_SELECTED)
              : `${selectedOptions.length} ${translate(STRINGS.SELECTED)}`}
          </div>
        </Flex>
        <div className="MyStaffingPreferences__ChevronIcon">
          <ChevronRightIcon />
        </div>
      </Flex>
      <AppOverlay>
        <AppBottomSheet
          isOpen={isOptionsModalOpen}
          onRequestClose={() => setIsOptionsModalOpen(false)}
          className="MyStaffingPreferences_SelectOptionsModal"
        >
          <Flex direction="column" gap={10}>
            {props.options.map((option) => (
              <MultiSelectOption
                key={`option-${option.value}`}
                label={option.title}
                value={option.value}
                checked={selectedOptions.includes(option)}
                onChange={handleChange}
              />
            ))}
          </Flex>
        </AppBottomSheet>
      </AppOverlay>
    </>
  );
}

export default StaffingPreferenceMultiSelect;

function MultiSelectOption<$Value>(props: {
  label: string;
  value: $Value;
  checked: boolean;
  onChange: (value: $Value, isChecked: boolean) => void;
}) {
  const [checked, setChecked] = React.useState(props.checked);

  const handleCheckedChange = (checkedState: boolean | "indeterminate") => {
    setChecked(!checked);
    props.onChange(props.value, checkedState === "indeterminate" ? false : checkedState);
  };

  return (
    <Flex direction="row" gap={10}>
      <Checkbox checked={checked} onCheckedChange={handleCheckedChange} />
      <div>{props.label}</div>
    </Flex>
  );
}
